import { t } from 'i18next'
export class PlantaValidator {
  private readonly isUnidade: boolean
  private readonly plantaId: string | undefined

  constructor({ isUnidade, plantaId }: { isUnidade: boolean; plantaId?: string }) {
    this.isUnidade = isUnidade
    this.plantaId = plantaId
  }

  validate(): string | null {
    const isPlantaVazia = this.isUnidade && !this.plantaId
    if (isPlantaVazia) return t('proposta:informacoes_iniciais.cards.planta.required')
    return null
  }
}
